






import Vue from "vue";
export default Vue.extend({
  props: {
    src: {
      type: String,
      default: "",
    },
    hasTitle: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
  methods: {
    resolveSrc(): string {
      // If src starts with /, it's an absolute path (public directory) - use as-is
      if (this.src.startsWith('/')) {
        return this.src;
      }
      // Otherwise, it's a relative path in assets directory
      return require(`@/assets${this.src}`);
    }
  }
});
